import React from "react";
import type { SidebarFormProps } from "./SidebarForm";
import { Input, ToggleSwitch } from "../../../../components";
import { useTranslations } from "../../../../contexts";
import { isEmpty } from "lodash";
import { DesignerSectionHeading } from "./DesignerSectionHeading";

export const SidebarFormServices: React.FC<SidebarFormProps> = (props) => {
  const i18n = useTranslations();

  return (
    <div className="border-b p-6" data-preview-section="features">
      <div className="flex items-start">
        <DesignerSectionHeading
          className="grow pb-4"
          title={i18n.Services}
          helpLabel={`${i18n.designerHelpFor} ${i18n.Services}`}
          helpText={i18n.designerServicesHelp}
        />
        <ToggleSwitch
          aria-label={`${i18n.designerShowSection}: ${i18n.Services}`}
          checked={props.form.services?.is_enabled}
          onChange={() =>
            props.setForm({
              ...props.form,
              services: {
                ...props.form.services,
                is_enabled: !props.form.services?.is_enabled,
              },
            })
          }
        />
      </div>
      {props.form.services?.is_enabled && (
        <div>
          <div className="pb-2">
            <Input
              variant="outlined"
              placeholder={i18n["title"]}
              example={i18n.designerServicesTitlePlaceholder}
              help={{
                label: `${i18n.designerHelpFor} ${i18n.title}`,
                content: i18n.designerServicesTitleHelp,
              }}
              value={props.form.services.title || ""}
              onChange={(event) => {
                props.setForm({
                  ...props.form,
                  services: {
                    ...props.form.services,
                    title: event.target.value,
                  },
                });
              }}
            />
          </div>
          {[
            ...(props.form.services?.items || []),
            { id: crypto.randomUUID() },
          ]?.map((item, index) => (
            <div className="pt-2" key={item.id}>
              <Input
                className="mb-2"
                variant="outlined"
                placeholder={i18n["title"]}
                example={i18n.designerServiceTitlePlaceholder}
                help={{
                  label: `${i18n.designerHelpFor} ${i18n.title}`,
                  content: i18n.designerServiceTitleHelp,
                }}
                value={item.title || ""}
                onChange={(event) => {
                  if (
                    isEmpty(event.target.value) &&
                    isEmpty(item.description)
                  ) {
                    props.setForm({
                      ...props.form,
                      services: {
                        ...props.form.services,
                        items: props.form.services?.items?.filter(
                          (i, index2) => index2 !== index
                        ),
                      },
                    });
                    return;
                  }
                  props.setForm({
                    ...props.form,
                    services: {
                      ...props.form.services,
                      items: props.form.services?.items
                        ?.slice(0, index)
                        .concat([
                          {
                            ...item,
                            title: event.target.value,
                          },
                        ])
                        .concat(props.form.services?.items?.slice(index + 1)),
                    },
                  });
                }}
              />
              <Input
                variant="outlined"
                placeholder={i18n.description}
                example={i18n.designerServiceDescriptionPlaceholder}
                asTextarea
                help={{
                  label: `${i18n.designerHelpFor} ${i18n.description}`,
                  content: i18n.designerServiceDescriptionHelp,
                }}
                value={item.description || ""}
                onChange={(event) => {
                  if (isEmpty(event.target.value) && isEmpty(item.title)) {
                    props.setForm({
                      ...props.form,
                      services: {
                        ...props.form.services,
                        items: props.form.services?.items?.filter(
                          (i, index2) => index2 !== index
                        ),
                      },
                    });
                    return;
                  }
                  props.setForm({
                    ...props.form,
                    services: {
                      ...props.form.services,
                      items: props.form.services?.items
                        ?.slice(0, index)
                        .concat([
                          {
                            ...item,
                            description: event.target.value,
                          },
                        ])
                        .concat(props.form.services?.items?.slice(index + 1)),
                    },
                  });
                }}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
